import { Paper, Stack, Box, Typography, alpha, Fade } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Iconify from "../../../minimals/components/iconify";

type EmptyStateProps = {
  hasSearched: boolean;
};

export function EmptyState({ hasSearched }: EmptyStateProps) {
  const theme = useTheme();

  return (
    <Fade in>
      <Paper
        elevation={0}
        sx={{
          p: 4,
          textAlign: "center",
          borderRadius: 2,
          border: `2px dashed ${theme.palette.divider}`,
          bgcolor: alpha(theme.palette.background.default, 0.5)
        }}
      >
        <Stack spacing={2} alignItems="center">
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: "50%",
              background: `linear-gradient(135deg, ${alpha(
                hasSearched ? theme.palette.warning.main : theme.palette.primary.main,
                0.1
              )} 0%, ${alpha(hasSearched ? theme.palette.warning.main : theme.palette.primary.main, 0.15)} 100%)`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: `2px solid ${alpha(
                hasSearched ? theme.palette.warning.main : theme.palette.primary.main,
                0.2
              )}`,
              boxShadow: `0 4px 16px ${alpha(
                hasSearched ? theme.palette.warning.main : theme.palette.primary.main,
                0.15
              )}`
            }}
          >
            <Iconify
              icon={hasSearched ? "eva:alert-circle-outline" : "eva:search-outline"}
              width={36}
              sx={{ color: hasSearched ? theme.palette.warning.main : theme.palette.primary.main }}
            />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={800} sx={{ mb: 0.5, letterSpacing: -0.3 }}>
              {hasSearched ? "No data available" : "Search for insights"}
            </Typography>
            <Typography variant="body2" color="text.secondary" fontWeight={500}>
              {hasSearched
                ? "No business insights found for this contact or company"
                : "Find contacts or companies to view detailed analytics"}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </Fade>
  );
}
